import type {WizardData} from '../index'
import type {
  AiAllocationAction,
  AiAllocationContext,
  LessonPlanningData,
} from '../types/teacherAllocationAi'
import {findTeacherByRef, getTeacherFullName, parseAllocationSlotKey} from './allocationIds'

export type MapActionsParams = {
  actions: AiAllocationAction[]
  context: AiAllocationContext
  lessonPlanningData: LessonPlanningData
  manualData: WizardData['manualData']
  defaultFrequency: string
  defaultDuration: string
}

export function mapActionsToLessonPlanningData(params: MapActionsParams): LessonPlanningData {
  const {actions, lessonPlanningData, manualData, defaultFrequency, defaultDuration} = params

  const teachers = manualData.teachers ?? []
  const next: LessonPlanningData = {...lessonPlanningData}

  actions.forEach((action) => {
    const {classKey, subjectName} = parseAllocationSlotKey(action.slotKey)
    if (!classKey || !subjectName) return

    const existing = next[classKey]?.[subjectName]
    const nextSubjectMap = {...(next[classKey] ?? {})}

    if (action.type === 'unassign') {
      nextSubjectMap[subjectName] = {
        teacher: '',
        teacherEmployeeId: '',
        frequency: existing?.frequency || defaultFrequency,
        duration: existing?.duration || defaultDuration,
      }
    } else {
      const teacher = findTeacherByRef(teachers, action.teacherEmployeeId, action.teacherName)
      nextSubjectMap[subjectName] = {
        teacher: teacher ? getTeacherFullName(teacher) : existing?.teacher || '',
        teacherEmployeeId: teacher ? String(teacher.employeeId ?? '').trim() : '',
        frequency: existing?.frequency || defaultFrequency,
        duration: existing?.duration || defaultDuration,
      }
    }

    next[classKey] = nextSubjectMap
  })

  return next
}

export function getPreviewSlotKeys(actions: AiAllocationAction[]): Set<string> {
  return new Set(actions.map((a) => a.slotKey).filter(Boolean))
}
